import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../constants/query'
import type { VendorDataValue } from '../constants/store'
import { VENDOR_DATA_ERRORS } from '../constants/vendor'
import { toApiMessage } from '../helpers/api-error'
import { loadVendorData } from '../helpers/vendor-api'
import { useAuth } from './useAuth'

export function useVendorData(options?: {
  includeCatalog?: boolean
}): VendorDataValue {
  const { vendorId } = useAuth()
  const includeCatalog = options?.includeCatalog ?? false
  const vendorQuery = useQuery({
    queryKey: QUERY_KEYS.vendor(vendorId ?? '', includeCatalog),
    queryFn: () => loadVendorData(vendorId!, { includeCatalog }),
    enabled: Boolean(vendorId),
  })
  const session = vendorQuery.data
  const error = vendorId
    ? vendorQuery.error
      ? toApiMessage(vendorQuery.error, VENDOR_DATA_ERRORS.loadFailed)
      : ''
    : VENDOR_DATA_ERRORS.unlinked

  return {
    vendor: session?.vendor ?? null,
    location: session?.vendor.location ?? null,
    products: session?.products ?? [],
    catalog: session?.catalog ?? [],
    loading: Boolean(vendorId) && vendorQuery.isPending && !session && !vendorQuery.error,
    error,
    refresh: async () => {
      await vendorQuery.refetch()
    },
  }
}
